export default [
  {
    name: 'SHOW_LOADING',
    // @ts-ignore
    callback: function(e) {
      // @ts-ignore
      this.$eventBus.$emit('SHOW_LOADING', e)
    },
  },
];
